export default {
  id: 'autoflow',
  application: 'autoflow',
  productName: 'Autoflow',
  logos: {},
  pdf: {
    text: { variable: '--bs-gray-900', fallback: '#212529' },
    muted: { variable: '--bs-gray-700', fallback: '#495057' },
    body: { variable: '--bs-gray-800', fallback: '#343a40' },
    border: { variable: '--bs-gray-300', fallback: '#dee2e6' },
    rowBorder: { variable: '--bs-gray-200', fallback: '#e9ecef' },
    header: { variable: '--bs-gray-100', fallback: '#f8f9fa' },
    accent: { variable: '--autoflow-primary-color', fallback: '#52b9e9' },
    warningText: { variable: '--bs-gray-900', fallback: '#212529' },
    font: 'helvetica',
    logo: null,
  },
};
